import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, H3 } from '../../StyledComponents';
import SectionTwoBg from '../../../assets/v2/backgrounds/homepage_sectiontwo.svg';
import Application from '../../../assets/ManageBenefits/application2.svg';
import Cost from '../../../assets/ManageBenefits/cost.svg';
import Field from '../../../assets/ManageBenefits/field.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Delivery from '../../../assets/ManageBenefits/delivery.svg';
import { BottomBanner } from '../BottomBanner';

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  padding-bottom: 3rem;
  background-color: #362767;
  background-image: url(${SectionTwoBg}),
    linear-gradient(to bottom, #362767, #362767);
`;
const ManageHeading = styled.div`
  text-align: center;
  color: #ffffff;
  margin-top: 5rem;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding-top: 2rem;
  padding-bottom: 3rem;
  /* flex-wrap: wrap; */
  width: 100%;
  margin-right: -3rem;
  margin-left: -3rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-top: 0rem;
    margin-top: -1rem;
    padding-bottom: 4rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  padding: 2rem;
  min-width: 250px;
  /* flex: 0 0 calc(25%); */
  margin-top: 2rem;
  margin-right: 1rem;
  background: white;
  border-radius: 4px;
  margin-left: 1rem;
  /* @media (max-width: 768px) {
    padding-right: 2rem;
    flex: 0 0 calc(25%);
    padding-left: 2rem;
  } */
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 400px) {
    min-width: unset;
  }
`;

const GridItemTitle = styled(H2)`
  /* font-size: 18px; */
  font-weight: normal;
  text-transform: uppercase;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #80629b;

  min-height: 3rem;
  margin-top: 1.5rem;
  margin-bottom: 0.8rem;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    min-height: 0;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }
`;
const GridItemDescription = styled(H3)`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #707070;
`;

const imageStyle = {
  height: '98px',
  width: '86px',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
`;

export default () => (
  <div>
    <Section>
      <ManageHeading>
        <H1 style={{ color: 'white' }}>Esper Benefits</H1>
      </ManageHeading>
      <GridContainer>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt="Run application deployment at scale"
              src={Application}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>Run application deployment at scale</GridItemTitle>
          <GridItemDescription>
            Deploy and manage your applications on your Android devices using
            fine-grained application rollout policies with automated rules.
          </GridItemDescription>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt="Support costs drastically reduced"
              src={Cost}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>Support costs drastically reduced</GridItemTitle>
          <GridItemDescription>
            Instantly debug and update app and device issues through OTA,
            removing the need for site visits.
          </GridItemDescription>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt="Field failures eliminated"
              src={Field}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Field failures
            <br /> eliminated
          </GridItemTitle>
          <GridItemDescription>
            Monitor your applications for field failures and trigger alerts
            easily, reducing device downtime and increasing performance.
          </GridItemDescription>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt="Continuous Delivery"
              src={Delivery}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Continuous <br />
            Delivery
          </GridItemTitle>
          <GridItemDescription>
            Around-the-clock continuous deployment of applications and Android
            OS updates through automated scaling and rollbacks.
          </GridItemDescription>
        </GridItem>
      </GridContainer>
    </Section>
    <BottomBanner
      description={`Test app-device compatibility with a custom emulator for your target device`}
      buttonText={`Test my device`}
      link="https://esper.io/test-lab"
    />
  </div>
);
